<template>
  <input
    v-model="formattedValue"
    type="text"
    :name="name"
    :disabled="disabled"
    @blur="onBlur"
    @focus="onFocus"
    @input.prevent
  />
</template>

<script>
import parsePhoneNumber from 'libphonenumber-js'

export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({ isInputActive: false, innerValue: null }),

  computed: {
    formattedValue: {
      get() {
        if (this.isInputActive) {
          // Cursor is inside the input field.
          // Unformat display value for user

          return this.clean(this.value)
        } else {
          // Format of the input when inactive
          // If the number is US, we format using NANP
          // Otherwise, we format using international (+countryCode)

          const cleanValue = this.clean(this.value)

          if (cleanValue.length === 0) {
            return ''
          } else {
            // Assume US for national numbers (no country code)
            const parsedValue = parsePhoneNumber(cleanValue, 'US')

            if (parsedValue) {
              if (parsedValue.country === 'US') {
                // Format in NANP
                const nationalNumber = parsedValue.nationalNumber
                return (
                  '(' +
                  nationalNumber.substr(0, 3) +
                  ') ' +
                  nationalNumber.substr(3, 3) +
                  '-' +
                  nationalNumber.substr(6, 4)
                )
              } else {
                // Format using international format
                return `+${parsedValue.countryCallingCode} ${parsedValue.nationalNumber}`
              }
            } else {
              return cleanValue
            }
          }
        }
      },
      set(modifiedValue) {
        this.innerValue = this.clean(modifiedValue)
        this.$emit('input', this.innerValue)
      }
    }
  },

  methods: {
    /**
     * Strip unsupported characters
     */
    clean(value) {
      const regexPattern = /^\+{1}|\d*/g
      return value
        ? new RegExp(regexPattern).test(value)
          ? value.match(regexPattern).join('')
          : ''
        : ''
    },
    onFocus() {
      this.isInputActive = true
      this.$emit('focus')
    },
    onBlur() {
      this.isInputActive = false
      this.$emit('blur')
    }
  }
}
</script>
